import { Header } from './header/Header';
import { InputSection } from './input/InputSection';
import { PreviewSection } from './preview/PreviewSection';
import { SelectSection } from './select/SelectSection';
import { Footer } from './footer/Footer';
import { SelectionContext, useSelectionState } from 'src/contexts/SelectionContext';
import styles from './CampaignAutomationPage.module.css';
import { ClientContextProvider } from 'src/contexts/ClientContextProvider';
import { AssetContextProvider } from 'src/contexts/AssetContextProvider';
import { CampaignCreationSection } from './create/CampaignCreationSection';
import { CampaignMetadataContextProvider } from 'src/contexts/CampaignMetadataContextProvider';
import { PreviewSessionProvider } from './preview/devicePreview/PreviewSessionProvider';
import { DevicePreviewNavigationProvider } from './preview/devicePreview/DevicePreviewNavigationProvider';

const CampaignAutomationPage = () => {
  const selectionState = useSelectionState();

  return (
    <div className={styles.provider}>
      <ClientContextProvider>
        <SelectionContext.Provider value={selectionState}>
          <PreviewSessionProvider>
            <DevicePreviewNavigationProvider>
              <AssetContextProvider>
                <main className={styles.page}>
                  <Header />
                  <SelectSection />
                  <CampaignMetadataContextProvider>
                    <div className={styles.mainContent}>
                      <div className={styles.leftColumn}>
                        <InputSection />
                        <CampaignCreationSection />
                      </div>
                      <PreviewSection />
                    </div>
                  </CampaignMetadataContextProvider>
                  <Footer />
                </main>
              </AssetContextProvider>
            </DevicePreviewNavigationProvider>
          </PreviewSessionProvider>
        </SelectionContext.Provider>
      </ClientContextProvider>
    </div>
  );
};

export { CampaignAutomationPage };
